import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { PickupService, UserPickupShopsService } from '@checkout-v2/feature';
import { MyShopService } from '@my-shop/feature';
import { CUSTOM_ICON_TYPE } from '@shared/models';
import { Pos } from '@shop/const';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

@Component({
  selector: 'sd-pickup-shop',
  templateUrl: './pickup-shop.component.html',
  styleUrls: ['./pickup-shop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorPickupShopComponent implements OnInit {
  iconType = CUSTOM_ICON_TYPE;

  @Input() shop: Pos;

  isRemove$: BehaviorSubject<boolean>;
  isActive$: Observable<boolean>;
  isMyShop$: Observable<boolean>;

  constructor(
    private pickupService: PickupService,
    private myShopService: MyShopService,
    private userPickupShopsService: UserPickupShopsService,
  ) {}

  ngOnInit(): void {
    this.isRemove$ = new BehaviorSubject(false);
    this.isActive$ = this.pickupService.activeShop$.pipe(map((shop) => shop?.name === this.shop?.name));
    this.isMyShop$ = this.myShopService.activeShop$.pipe(map((shop) => shop?.name === this.shop?.name));
  }

  selectShop(): void {
    this.isRemove$
      .pipe(take(1))
      .subscribe((isRemove) => void (!isRemove && this.pickupService.setShop(this.shop.name)));
  }

  removeShop(): void {
    this.isRemove$.pipe(take(1)).subscribe((isRemove) => {
      if (!isRemove) {
        this.isRemove$.next(true);
        this.userPickupShopsService.remove(this.shop.name);
      }
    });
  }
}
